export enum CmsApiErrorCodes {
  General = 0,
  SameEmail = 1,
  InvalidFileFormat = 2,
  EmptyFile = 3,
  FileLimitExceeded = 4,
  FileNameInvalid = 5,
  TreatAsHackingOrSpam = 6,
}
